/** The policy columns the dashboards' deal tables and the policy list views share. */
import { toUsDate, type PolicySummary } from "@tlcrm/shared";

import type { Column } from "../../components/DataTable";
import { PostSaleMark, StageMark } from "../../components/ui";
import { money } from "../../lib/format";

export const dealColumns = {
  policy: {
    header: "Policy",
    cell: (p: PolicySummary) => <span className="primary">{p.name}</span>,
  },
  customer: { header: "Customer", cell: (p: PolicySummary) => p.customerName },
  stage: { header: "Stage", cell: (p: PolicySummary) => <StageMark stage={p.stage} /> },
  premium: {
    header: "Total Premium",
    cell: (p: PolicySummary) => <span className="mono">{money(p.totalPremium, true)}</span>,
    num: true,
  },
  carrier: {
    header: "Carrier",
    cell: (p: PolicySummary) => p.carrier ?? <span className="t3">–</span>,
  },
  dateSold: {
    header: "Date Sold",
    cell: (p: PolicySummary) => <span className="mono">{toUsDate(p.dateSold)}</span>,
  },
  effective: {
    header: "Effective",
    cell: (p: PolicySummary) => (
      <span className="mono">{p.effectiveDate ? toUsDate(p.effectiveDate) : "–"}</span>
    ),
  },
  cancelled: {
    header: "Cancellation Date",
    cell: (p: PolicySummary) => (
      <span className="mono">{p.cancellationDate ? toUsDate(p.cancellationDate) : "–"}</span>
    ),
  },
  reason: {
    header: "Reason",
    cell: (p: PolicySummary) => p.cancellationReason ?? <span className="t3">–</span>,
  },
  postSale: {
    header: "Post-Sale",
    cell: (p: PolicySummary) => <PostSaleMark status={p.postSaleStatus} />,
  },
  callType: {
    header: "Call Type",
    cell: (p: PolicySummary) => p.callType ?? <span className="t3">–</span>,
  },
  owner: { header: "Owner", cell: (p: PolicySummary) => p.owner.fullName },
} satisfies Record<string, Column<PolicySummary>>;
